export enum SummaryContainerFields {
  OverwriteAmount = 'overwriteAmount',
  OverwrittenAmount = 'overwrittenAmount',
}
